import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';

// --- Interfaces ---
import type { ICart } from '@interfaces/cart';
import type { ICartBuyFiscalOptions } from '@interfaces/fiscal';
import type { IOrder } from '@interfaces/order';
import type { IPayment, IProductCart } from '@interfaces/productCart';

export interface IGetCartParams {
	userId?: number;
	storeId?: number;
	priceListId?: number;
	tenantId?: number;
	page?: number;
	pageLimit?: number;
}

@Injectable({
	providedIn: 'root',
})
export class CartService {
	constructor(private readonly _http: HttpClient) {}

	// --- GET endpoints ---
	getCart(queryParams?: IGetCartParams) {
		return this._http
			.get<ICart>('cart', {
				params: (<unknown>queryParams) as HttpParams,
			})
			.pipe(shareReplay());
	}

	// --- POST endpoints ---
	saveCart(cart: IProductCart[]) {
		return this._http
			.post<ICart>('cart/save', { items: cart })
			.pipe(shareReplay());
	}

	buyCart(
		cart: IProductCart[],
		obs: string,
		addressId: number,
		payment: IPayment,
		uuid: string,
		fiscalOptions?: ICartBuyFiscalOptions
	) {
		const headers = new HttpHeaders({
			'idp-key': uuid,
		});

		return this._http.post<IOrder>(
			'cart/buy',
			{
				items: cart,
				obs,
				addressId,
				...payment,
				...(fiscalOptions?.orderTypeId != null
					? { orderTypeId: fiscalOptions.orderTypeId }
					: {}),
				...(fiscalOptions?.sellingOperationId != null
					? { sellingOperationId: fiscalOptions.sellingOperationId }
					: {}),
				...(fiscalOptions?.storeId != null
					? { storeId: fiscalOptions.storeId }
					: {}),
			},
			{ headers }
		);
	}
}
